import './index.erb';
import './index.rb';
import './index.scss';

const segmentsPath = [
  'questoes-de-concursos',
  'questoes-militares',
  'questoes-da-oab',
  'questoes-do-enem',
  'questoes-de-vestibular'
];

const segmentsName = {
  'questoes-de-concursos': 'Concursos',
  'questoes-militares': 'Militares',
  'questoes-da-oab': 'OAB',
  'questoes-do-enem': 'ENEM',
  'questoes-de-vestibular': 'Vestibular'
};

class HandleTitleSegment {
  constructor(component) {
    this.baseUrl = this.setBaseUrl();
    this.initialSegment = this.hasSegment();
    this.dynamicSegment = this.hasSegment();
    this._pathnameWithoutSegment = this.pathnameWithoutSegment();
    this.component = component;
    this.$buttons = $('#buttons-container button');
    this.$toogleModalButtons = $('.js-toggle-modal');
    this.$submitButton = $('#submit-button');
    this.$modal = $('#js-handle-segment-modal');
    this.$segmentTitle = $('#segment-title');
    this.init();
  }

  init() {
    this.activateSegmentButton();
    this.addClickEventToButtons();
    this.redirectToSegment();
    this.toggleModal();
  }

  toggleModal() {
    this.$toogleModalButtons.on('click', () => {
      if (this.$modal.hasClass('hidden')) {
        this.openModal();
        return;
      }

      this.closeModal();
    });
  }

  openModal() {
    this.$modal.removeClass('hidden');
    $('body').addClass('q-select-no-scroll');
  }

  closeModal() {
    this.$modal.addClass('hidden');
    this.setToInitialSegment();
    $('body').removeClass('q-select-no-scroll');
  }

  setBaseUrl() {
    const url = new URL(window.location.href);
    return url.origin;
  }

  hasSegment() {
    const url = new URL(window.location.href);
    const segment = url.pathname.split('/')[1];

    if (segmentsPath.includes(segment)) {
      return segment;
    } else {
      return null;
    }
  }

  pathnameWithoutSegment() {
    const url = new URL(window.location.href);
    const pathParts = url.pathname
      .split('/')
      .filter(part => part && !segmentsPath.includes(part));
    return '/' + pathParts.join('/');
  }

  activateSegmentButton() {
    this.$buttons.each((i, button) => {
      const $button = $(button);

      if ($button.data('segment') === this.dynamicSegment) {
        $button.addClass('active');
      } else {
        $button.removeClass('active');
      }
    });
  }

  addClickEventToButtons() {
    this.$buttons.on('click', event => {
      const $button = $(event.target);
      const segment = $button.data('segment');
      this.handleButtonClick(segment);
    });
  }

  setToInitialSegment() {
    if (this.initialSegment === this.dynamicSegment) {
      return;
    }

    this.dynamicSegment = this.initialSegment;
    this.activateSegmentButton();
  }

  handleButtonClick(segment) {
    if (segment === this.dynamicSegment) {
      return;
    }

    this.dynamicSegment = segment;
    this.activateSegmentButton();
  }

  redirectToSegment() {
    const url = new URL(window.location.href);
    const urlSegment = url.pathname.split('/')[1];

    this.$submitButton.on('click', () => {
      if (this.dynamicSegment === urlSegment) {
        this.$modal.addClass('hidden');
      } else {
        const url = `${this.baseUrl}/${this.dynamicSegment}${this._pathnameWithoutSegment}`;
        this.trackEvents();
        Turbolinks.visit(url);
      }
    });
  }

  trackEvents() {
    UserTracker.emit('event', {
      eventName: 'study segment changed',
      data: {
        'initial segment': segmentsName[this.initialSegment],
        'final segment': segmentsName[this.dynamicSegment]
      }
    });
  }
}

const $components = $('.js-handle-title-segment');
$components.each((i, component) => new HandleTitleSegment(component));
